import { render } from "./BrandListView.vue?vue&type=template&id=136fe327"
import script from "./BrandListView.vue?vue&type=script&lang=js"
export * from "./BrandListView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/views/BrandListView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "136fe327"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('136fe327', __exports__)) {
    api.reload('136fe327', __exports__)
  }
  
  module.hot.accept("./BrandListView.vue?vue&type=template&id=136fe327", () => {
    api.rerender('136fe327', render)
  })

}


export default __exports__